const Manager = [
	{
		title: '主页',
		key: 'Home',
		icon: 'h-icon-home'
	},
	{
		title: '凭证',
		key: 'vouchers',
		icon: 'h-icon-star',
		children: [
			{
				title: '新增凭证',
				key: 'VoucherForm'
			},
			{
				title: '凭证列表',
				key: 'Voucher'
			},
			{
				title: '自动转账',
				key: 'AutoTransfer'
			},
			{
				title: '凭证汇总表',
				key: 'SubjectSummary'
			},
			{
				title: '业务凭证',
				key: 'Tripartite'
			},
			{
				title: '进销存单据',
				key: 'JxcVoucher'
			}
		]
	},
	{
		title: '帐薄',
		key: 'AccountBooks',
		icon: 'h-icon-task',
		children: [
			{
				title: '明细账',
				key: 'DetailedAccounts'
			},
			{
				title: '出纳日记账',
				key: 'CashierJournal'
			},
			{
				title: '总账',
				key: 'GeneralLedger'
			},
			{
				title: '科目余额表',
				key: 'SubjectBalance'
			},
			{
				title: '序时账',
				key: 'TimeSeries'
			},
			{
				title: '多栏账',
				key: 'MultiColumnLedger'
			},
			{
				title: '核算项目明细账',
				key: 'AuxiliaryAccountingDetail'
			},
			{
				title: '核算项目余额表',
				key: 'AuxiliaryAccountingBalance'
			},
			{
				title: '账龄分析表',
				key: 'AgeAnalysis'
			}
		]
	},
	{
		title: '报表',
		key: 'Reports',
		icon: 'h-icon-search',
		children: [
			{
				title: '系统报表',
				key: 'ReportList'
			},
			{
				title: '利润表季报',
				key: 'ProfitQuarter'
			},
			{
				title: '现金流量表季报',
				key: 'CashFlowQuarter'
			},
			{
				title: '费用明细表',
				key: 'FeeDetailReport'
			},
			{
				title: '资产对账',
				key: 'AssetsCheck'
			},
			{
				title: '自定义报表',
				key: 'CustomReport'
			}
		]
	},
	{
		title: '发票',
		key: 'Invoice',
		icon: 'fa fa-file-text-o',
		children: [
			{
				title: '销项发票',
				key: 'OutputInvoice'
			},
			{
				title: '进项发票',
				key: 'InputInvoice'
			},
			{
				title: '智能开票',
				key: 'IntelligentInvoicing'
			},
			{
				title: '发票勾选',
				key: 'InvoiceCheckSelect'
			},
			{
				title: '费用单据',
				key: 'Expense'
			},
			{
				title: '无票收入',
				key: 'NonIncome'
			}
		]
	},
	{
		title: '资金',
		key: 'Cashier',
		icon: 'fa fa-money',
		children: [
			{
				title: '资金日记账',
				key: 'FundsJournal'
			},
			{
				title: '内部转账',
				key: 'InternalTransfer'
			},
			{
				title: '资金报表',
				key: 'FundsReport'
			},
			{
				title: '核对总账',
				key: 'CheckUp'
			},
			{
				title: '收支类别',
				key: 'FundsCategory'
			},
			{
				title: '账户设置',
				key: 'FundsAccount'
			}
		]
	},
	{
		title: '工资',
		key: 'SalaryMenu',
		icon: 'h-icon-user',
		children: [
			{
				title: '工资列表',
				key: 'Salary'
			},
			{
				title: '员工信息',
				key: 'SalaryEmployee'
			},
			{
				title: '五险一金设置',
				key: 'SocialSecurity'
			},
			{
				title: '个税申报',
				key: 'IitDeclare'
			},
			{
				title: '生产经营所得申报',
				key: 'ScjyDeclare'
			},
			{
				title: '生产经营所得年度汇缴',
				key: 'ScjyAnnual'
			}
		]
	},
	{
		title: '存货',
		key: 'Inventory',
		icon: 'fa fa-cubes',
		children: [
			{
				title: '单据管理',
				key: 'InventoryBillManager'
			},
			{
				title: '资金管理',
				key: 'InventoryFundManagement'
			},
			{
				title: '统计报表',
				key: 'InventoryReport'
			},
			{
				title: '期初数据',
				key: 'InventoryOpeningBalance'
			},
			{
				title: '基础设置',
				key: 'InventoryBasicSetting'
			},
			{
				title: '成本核算期间',
				key: 'InventoryCostPeriod'
			}
		]
	},
	{
		title: '资产',
		key: 'AssetsMenu',
		icon: 'h-icon-task',
		children: [
			{
				title: '资产管理',
				key: 'Assets'
			},
			{
				title: '资产类别',
				key: 'AssetsCategory'
			},
			{
				title: '折旧摊销明细表',
				key: 'AssetsDepreciationList'
			},
			{
				title: '资产汇总',
				key: 'AssetsSummary'
			}
		]
	},
	{
		title: '申报',
		key: 'Tax',
		icon: 'fa fa-bank',
		children: [
			{
				title: '企业税申报',
				key: 'DeclareInfo'
			},
			{
				title: '工商年报',
				key: 'GsAnnual'
			},
			{
				title: '社保费申报',
				key: 'SocialDeclare'
			},
			{
				title: '社保费申报(广东)',
				key: 'ShbxGdDeclare'
			},
			{
				title: '漏报检查',
				key: 'TaxCheck'
			}
		]
	},
	{
		title: '结账',
		key: 'CheckList',
		icon: 'h-icon-complete'
	},
	{
		title: '财税智能体',
		key: 'AiAgent',
		icon: 'h-icon-message'
	},
	{
		title: '设置',
		key: 'Setting',
		icon: 'h-icon-setting',
		children: [
			{
			title: '账套',
			key: 'Account'
		},
		{
			title: '参数中心',
			key: 'SetsSettings'
		},
		{
			title: '科目',
			key: 'Subject'
		},
		{
			title: '期初',
			key: 'Initial'
		},
		{
			title: '币别',
			key: 'Currency'
		},
		{
			title: '汇率管理',
			key: 'ExchangeRate'
		},
			{
				title: '凭证字',
				key: 'VoucherWord'
			},
			{
				title: '辅助核算',
				key: 'AccountingCategory'
			},
			{
				title: '辅助核算档案',
				key: 'AssistingAccounting'
			},
			{
			title: '权限设置',
			key: 'PermissionSetting'
		},
		{
			title: '角色管理',
			key: 'RoleManage'
		},
			{
				title: '备份恢复',
				key: 'Backup'
			},
			{
				title: '旧账导入',
				key: 'SyncImport'
			},
			{
				title: '审计数据导出',
				key: 'AuditExport'
			},
			{
				title: '审计日志',
				key: 'AuditLog'
			}
		]
	}
];

const Making = [
	{
		title: '主页',
		key: 'Home',
		icon: 'icon-monitor'
	},
	{
		title: '凭证',
		key: 'vouchers',
		icon: 'icon-grid-2',
		children: [
			{
				title: '新增凭证',
				key: 'VoucherForm'
			},
			{
				title: '凭证列表',
				key: 'Voucher'
			}
		]
	},
	{
		title: '结账',
		key: 'CheckList',
		icon: 'icon-disc',
	},
	{
		title: '帐薄',
		key: 'AccountBooks',
		icon: 'icon-paper',
		children: [
			{
				title: '明细账',
				key: 'DetailedAccounts'
			},
			{
				title: '总账',
				key: 'GeneralLedger'
			},
			{
				title: '科目余额',
				key: 'SubjectBalance'
			},
			{
				title: '科目汇总',
				key: 'SubjectSummary'
			},
			{
				title: '核算项目明细账',
				key: 'AuxiliaryAccountingDetail'
			},
			{
				title: '核算项目余额',
				key: 'AuxiliaryAccountingBalance'
			}
		]
	},
	{
		title: '报表',
		key: 'ReportList',
		icon: 'icon-bar-graph-2'
	},
	{
		title: '设置',
		key: 'Setting',
		icon: 'icon-cog',
		children: [
			{
				title: '账套',
				key: 'Account'
			}
		]
	}
];

const View = [
	{
		title: '主页',
		key: 'Home',
		icon: 'icon-monitor'
	},
	{
		title: '凭证',
		key: 'vouchers',
		icon: 'icon-grid-2',
		children: [
			{
				title: '凭证列表',
				key: 'Voucher'
			}
		]
	},
	{
		title: '帐薄',
		key: 'AccountBooks',
		icon: 'icon-paper',
		children: [
			{
				title: '明细账',
				key: 'DetailedAccounts'
			},
			{
				title: '总账',
				key: 'GeneralLedger'
			},
			{
				title: '科目余额',
				key: 'SubjectBalance'
			},
			{
				title: '科目汇总',
				key: 'SubjectSummary'
			},
			{
				title: '核算项目明细账',
				key: 'AuxiliaryAccountingDetail'
			},
			{
				title: '核算项目余额',
				key: 'AuxiliaryAccountingBalance'
			}
		]
	},
	{
		title: '报表',
		key: 'ReportList',
		icon: 'icon-bar-graph-2'
	},
	{
		title: '设置',
		key: 'Setting',
		icon: 'icon-cog',
		children: [
			{
				title: '账套',
				key: 'Account'
			}
		]
	}
];

export default {
	Manager,
	Making,
	View
};
